import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
import { useContextSelector } from "../ContextSelector";
import TableContext from "../context/TableContext";
export default function FooterRow(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var getComponent = useContextSelector(TableContext, 'getComponent');
  var Component = getComponent(['footer', 'row'], 'tr');
  return /*#__PURE__*/React.createElement(Component, props, children);
}